exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.formulate-input-dropdown li[data-v-54805a1a]:hover,\n.formulate-input-dropdown li[data-is-selected][data-v-54805a1a] {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n", ""]);

// exports
